import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "settings-fixed-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "settings-fixed-header--title" }, [
    /*#__PURE__*/_createElementVNode("h1", null, "Forms")
  ])
], -1)
const _hoisted_2 = { class: "forms-wrapper with-fixed-header p-top-20" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PAFForm = _resolveComponent("PAFForm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_PAFForm)
    ])
  ], 64))
}